import { createAction } from 'redux-actions';
import * as complianceReviewWizardTypes from './complianceReviewWizardTypes';
import { createUpdateAction } from '../../../../utils/actions';

export const loadComplianceReviewData = createAction(complianceReviewWizardTypes.LOAD_COMPLIANCE_REVIEW_DATA);
export const updateComplianceReview = createUpdateAction(complianceReviewWizardTypes.UPDATE_COMPLIANCE_REVIEW);
export const resetComment = createAction(complianceReviewWizardTypes.RESET_COMMENT, ComplianceReviewId => ({
  ComplianceReviewId,
}));
